import React from 'react';
import '../styles.scss';

export default function DreamDrawBlock({ children }) {
  return <div className="dream-draw-wrap">{children}</div>;
}
